var render = function render(){var _vm=this,_c=_vm._self._c;return _c('upload',{ref:"file_upload",attrs:{"id":_vm.id},on:{"uploaded":_vm.handleUpload,"filesToUpload":_vm.filesToUpload}})
}
var staticRenderFns = []

export { render, staticRenderFns }